import { lazy } from 'react';

import { withSuspense } from '@/shared/lib/hocs/with-suspense.hoc';

export const SearchBoatMobile = withSuspense(lazy(() => import('./search-boat-mobile.component')));
